const items = [
    {
        id: 1,
        title: "E-commerce App",
        category: "Mobile App Design",
        image: "images/work-1.png",
        alt: "Ecommerce",
        link: ""
    },
    {
        id: 2,
        title: "Food Ordering App",
        category: "Mobile App Design",
        image: "images/work-2.png",
        alt: "Food Ordering App",
        link: ""
    },
    {
        id: 3,
        title: "Local Dish Restuarant Finder",
        category: "Mobile App Design",
        image: "images/work-3.png",
        alt: "local dish app",
        link: ""
    },
    {
        id: 4,
        title: "Joanah Consulting",
        category: "Web Application",
        image: "images/joanah home.png",
        alt: "consultancy",
        link: "https://joanaheyereconsulting.com"
    },
    {
        id: 5,
        title: "Davidston Organic Farm",
        category: "Web Application",
        image: "images/davidstonfarm.png",
        alt: "Davidston organic farm",
        link: "https://davidstonfarm.com"
    },
    {
        id: 6,
        title: "Davidston Store",
        category: "Web Application",
        image: "images/davidstonstore.png",
        alt: "Davidston store",
        link: "https://store.davidstonfarm.com"
    },
]

export default items;